module.exports = __webpack_public_path__ + "img/set-employment.1fadd89b.png";